/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { textEllipsis } from '../../../shared/utils/smartutils';

export default function (t) {
  return [
    {
      title: t('general.student'),
      field: 'student.fullName',
      cellStyle: textEllipsis,
      render: (rowData) => (
        <span className="tooltip-test" title={rowData.student.fullName}>
          {rowData.student.fullName}
        </span>
      ),
    },
    {
      title: t('general.shift'),
      field: 'schoolShift.name',
    },
    {
      title: t('general.enrollment'),
      field: 'initialDate',
    },
    {
      title: t('general.final-time'),
      field: 'finalDate',
    },
    {
      title: t('general.active'),
      field: 'activeDescription',
    },
  ];
}
